<div>
  <nz-timeline>
    <nz-timeline-item nzColor="green" i18n><nz-tag>{{processInstance?.startTime | date: 'dd.MM.yyyy HH:mm:ss'}}</nz-tag> - Старт процесса</nz-timeline-item>
    <nz-timeline-item *ngFor="let task of tasks?.data" nzColor="red">
      <nz-tag nz-tooltip [nzTooltipTitle]="startTaskLocalize" *ngIf="task.startTime">
        <i nz-icon nzType="clock-circle"
           nzTheme="outline"></i> {{task.startTime | date: 'dd.MM.yyyy HH:mm:ss'}}
      </nz-tag>
      <nz-tag nz-tooltip [nzTooltipTitle]="endTaskLocalize" *ngIf="task.endTime">
        <i nz-icon nzType="stop"
           nzTheme="outline"></i> {{task.endTime | date: 'dd.MM.yyyy HH:mm:ss'}}
      </nz-tag>
      <p>{{task.name}}</p>
      <span *ngIf="task.assignee">
        <nz-tag nzColor="blue" *ngIf="task.assignee !== 'anonymousUser'">{{(userInfo(task.assignee!) | async)?.email}}</nz-tag>
        <nz-tag nzColor="blue" *ngIf="task.assignee === 'anonymousUser'"> -&#45;&#45; </nz-tag>
      </span>
    </nz-timeline-item>
    <nz-timeline-item nzColor="green" *ngIf="processInstance?.endTime" i18n><nz-tag>{{processInstance?.endTime | date: 'dd.MM.yyyy HH:mm:ss'}}</nz-tag> - Завершение процесса</nz-timeline-item>
  </nz-timeline>
</div>
